import React from 'react';
import { SxProps, Tab } from '@mui/material';
import { headingFontBold, vars } from '../../Theme';

/** Base button styles. */
const btnSx: SxProps = {
    textTransform: 'none',
    whiteSpace: 'nowrap',
    color: vars.font,
    ...headingFontBold,
    opacity: 1,
};

/** Styles for an active button. */
const activeSx: SxProps = {
    color: vars.brandGreen,

    '&:after': {
        backgroundColor: vars.brandGreen,
        position: 'absolute',
        borderRadius: 1,
        content: '""',
        height: 2,
        bottom: 4,
        right: 4,
        left: 4,
    },
};

/**
 * Button component for the ProjectViewControls component.
 */
export default ({ key, label, active, onClick }: IViewButtonProps) => (
    <Tab
        key={key}
        label={label}
        onClick={onClick}
        sx={active ? { ...btnSx, ...activeSx } : { ...btnSx }}
    />
);

interface IViewButtonProps {
    key: string;
    label: string;
    active: boolean;
    onClick: () => void;
}
